<template>
    <div>
        <section class="payment-methods-table  border-[none] text-[12px] leading-[14px] md:text-sm md:leading-[21px]">
            <div
                class="flex flex-wrap  heading-row items-center text-center no-gutters bg-gdc-gray-900 rounded text-white flex-nowrap mb-[5px]"
                :class="'row-cols-' + numberOfCols">
                <div class="relative flex-grow flex-1" :class="[fullWidthTable ? 'max-w-[20%]' : '']">
                    <div class="p-2 sm:p-4">
                        <span>Payment Method</span>
                    </div>
                </div>
                <div class="relative flex-grow flex-1" :class="[fullWidthTable ? 'max-w-[20%]' : '']">
                    <div class="p-2 sm:p-4">
                        <span>Name</span>
                    </div>
                </div>
                <div class="relative flex-grow flex-1" :class="[fullWidthTable ? 'max-w-[20%]' : '']">
                    <div class="p-2 sm:p-4">
                        <span>Deposit Amount</span>
                    </div>
                </div>
                <div class="relative flex-grow max-w-[20%] flex-1" v-if="fullWidthTable">
                    <div class="p-2 sm:p-4">
                        <span>Withdrawal Amount</span>
                    </div>
                </div>

                <div class="relative flex-grow max-w-[20%] flex-1" v-if="fullWidthTable">
                    <div class="p-2 sm:p-4">
                        <span>Withdraw Time</span>
                    </div>
                </div>
            </div>
            <div v-if="paymentMethods.length > 0">
                <div
                    :class="'row-cols-' + numberOfCols"
                    class="flex flex-wrap  data-row text-center no-gutters p-2 bg-[#ececec] rounded flex-nowrap mt-0 mb-[5px] mx-0 p-0 border-[none] items-center"
                    v-for="payment in paymentMethods"
                >
                    <div class="relative flex-grow flex-1 px-4" :class="[fullWidthTable ? 'max-w-[20%]' : '']">
                        <div>
                            <div>
                                <img
                                    :data-src="payment.logo"
                                    :title="payment.brand_feature_key.feature"
                                    :alt="payment.brand_feature_key.feature"
                                    class="max-w-full h-auto lazyload"
                                >
                            </div>
                        </div>
                    </div>

                    <div class="relative flex-grow flex-1 px-4" :class="[fullWidthTable ? 'max-w-[20%]' : '']">
                        <div>
                            <div>
                                <span>
                                    {{ payment.brand_feature_key.feature }}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="relative flex-grow flex-1 px-4" :class="[fullWidthTable ? 'max-w-[20%]' : '']">
                        <div>
                            <div>
                                <span v-if="payment.deposit_amount">
                                    ${{ payment.deposit_amount }}
                                </span>
                                <span v-else>
                                    -
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="relative flex-grow max-w-[20%] flex-1 px-4" v-if="fullWidthTable">
                        <div>
                            <div>
                                <span v-if="payment.withdrawal_amount">
                                    {{ payment.withdrawal_amount }}
                                </span>
                                <span v-else>
                                    -
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="relative flex-grow max-w-[20%] flex-1 px-4" v-if="fullWidthTable">
                        <div>
                            <div>
                                <span v-if="payment.withdraw_time">
                                    {{ payment.withdraw_time }}
                                </span>
                                <span v-else>
                                    -
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="text-center p-3" v-else>No payments method for the selected state.</div>
        </section>
    </div>

</template>

<script>
export default {
    name: 'payment-methods-table',
    props: {
        brandFeatures: {
            type: Array,
            require: true
        },
        numberOfCols: {
            type: Number,
            default: 5
        },
        state: {
            type: String,
            require: true
        }
    },
    data: function () {
        return {
            paymentIds: [],
            paymentMethods: [],
            brandFeatureData: [],
            fullWidthTable: false
        }
    },
    mounted: function () {
        this.fetchData();
    },
    methods: {
        fetchData() {
            this.paymentIds = [];
            this.paymentMethods = [];
            this.fullWidthTable = this.numberOfCols === 5 ? true : false;
            this.brandFeatures.filter(payment => {
                if (payment.us_state.code == this.state && !this.paymentIds.includes(payment.id)) {
                    this.paymentIds.push(payment.id);
                    this.paymentMethods.push(payment);
                }
            });
        }
    },
    watch: {
        state() {
            this.fetchData();
        }
    },
}
</script>
